import { render } from "./AttachPhoto.vue?vue&type=template&id=93ac4802&scoped=true&ts=true"
import script from "./AttachPhoto.vue?vue&type=script&lang=ts"
export * from "./AttachPhoto.vue?vue&type=script&lang=ts"

import "./AttachPhoto.vue?vue&type=style&index=0&id=93ac4802&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93ac4802"]])

export default __exports__